var _path, _rect, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVacancySeats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2676 20C19.2676 19.4477 19.7153 19 20.2676 19H38.1077C38.66 19 39.1077 19.4477 39.1077 20V35.9091H19.2676V20Z",
    fill: "#D946EF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 37.8198,
    width: 26.3697,
    height: 6.54546,
    rx: 3.27273,
    fill: "#D946EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5059 45.7275H23.5332V52.1875C23.5332 53.7409 22.2739 55.0003 20.7205 55.0003V55.0003C18.9451 55.0003 17.5059 53.561 17.5059 51.7857V45.7275Z",
    fill: "#D946EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.834 45.7275H40.8614V52.1875C40.8614 53.7409 39.602 55.0003 38.0486 55.0003V55.0003C36.2732 55.0003 34.834 53.561 34.834 51.7857V45.7275Z",
    fill: "#D946EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.288 3C27.1451 3 26 5.29016 26 6.82507V7.04429C26 7.31229 26.2192 7.50723 26.4629 7.50723H27.8029C28.0709 7.50723 28.2659 7.28801 28.2659 7.04429V6.82507C28.2659 6.75199 28.2902 5.26584 30.288 5.26584C31.5792 5.26584 32.1395 5.75305 32.1395 6.87384C32.1395 7.60477 31.2868 8.35997 30.5072 9.01782C29.4352 9.89488 28.9237 10.8207 28.9237 11.8683L28.9236 12.3798C28.9236 12.6478 29.1428 12.8428 29.3865 12.8428H30.7265C30.9945 12.8428 31.1894 12.6235 31.1894 12.3798V11.8681C31.1894 11.7463 31.1894 11.4052 31.9446 10.7718C32.8705 10.0166 34.4297 8.74969 34.4297 6.87366C34.4052 4.99785 33.3334 3 30.2881 3H30.288Z",
    fill: "#D946EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5544 15.3274C31.5544 16.1348 30.9 16.7893 30.0927 16.7893C29.2853 16.7893 28.6309 16.1348 28.6309 15.3274C28.6309 14.5202 29.2853 13.8657 30.0927 13.8657C30.9 13.8657 31.5544 14.5202 31.5544 15.3274Z",
    fill: "#D946EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacancySeats);
export default __webpack_public_path__ + "static/media/VacancySeats.146e96d0f1cbacf3d40479d9f8383397.svg";
export { ForwardRef as ReactComponent };